exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  font-size: 1.5em;\r\n  display: inline;\r\n  color: black;\r\n  text-align: center;\r\n}\r\n.red{\r\n  background-color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/plenary-speakers/speaker/speaker.component.css
// module id = ../../../../../src/app/main/plenary-speakers/speaker/speaker.component.css
// module chunks = main